import React, { useEffect } from "react";
import { useAppContext } from "../../context/useAppContext";
import { categoriesQuery, topCategoryQuery } from "../../constants/api";
import { useFirebase } from "../../hooks/firebase/useFirebase";
import { sCategories } from "../../constants/strings";

export const DataProvider = () => {
  const { updateContext } = useAppContext();

  const { listenData: getCategories, data: categories } = useFirebase();

  const { listenData: getTopMenu, data: topMenu } = useFirebase();

  useEffect(() => {
    getCategories(categoriesQuery);
    getTopMenu(topCategoryQuery);
  }, []);

  useEffect(() => {
    updateContext(sCategories, categories);
    updateContext("topMenu", topMenu);
  }, [categories, topMenu]);

  //   function getGlobalData(key) {
  //     switch (key) {
  //       case STATUS_CATEGORIES:
  //         getCategories(categoriesQuery).then(() => {
  //           updateContext("categories", categories);
  //         });
  //         break;
  //       case STATUS_SHOPS:
  //         // getShops(categoriesQuery).then(()=>{
  //         //     updateContext("categories", categories);
  //         // });
  //         break;

  //       default:
  //         break;
  //     }
  //   }
};
